package ui.styles

import emotion.css.ClassName
import ui.pages.Area
import web.cssom.*

object ScheduleChangeStyle {
    val scheduleChangeMainBox = ClassName(ClassName("SC_scheduleChangeMainBox")){
        display = Display.grid

        gap = 10.px
        width = 100.pct
        maxWidth = 920.px

        gridTemplateColumns = array(
            Auto.auto
        )

        gridTemplateRows = array(
            Auto.auto,
            Auto.auto,
            Auto.auto,
            Auto.auto,
        )

        gridTemplateAreas = GridTemplateAreas(
            arrayOf(Area.ScheduleBox.title),
            arrayOf(Area.ScheduleBox.scheduleMain),
            arrayOf(Area.ScheduleBox.selectedInfo),
            arrayOf(Area.ScheduleBox.confirmButton)
        )
    }

    val scheduleTitle = ClassName(ClassName("sc_schedule_title")){
        gridArea = Area.ScheduleBox.title
    }

    val scheduleMain = ClassName(ClassName("SC_scheduleMain")){
        gridArea = Area.ScheduleBox.scheduleMain
        minHeight = 30.vh
        listStyle = None.none
    }

    val selectedInfo = ClassName(ClassName("SC_selectedInfo")){
        gridArea = Area.ScheduleBox.selectedInfo
    }

    val confirmButton = ClassName(ClassName("SC_confirmButton")){
        gridArea = Area.ScheduleBox.confirmButton
    }

    val listHandler = ClassName(ClassName("SC_listHandler")){
        listStyle = None.none
    }

    val listHeader = ClassName(ClassName("SC_listHeader")){
        paddingTop = 10.px
        paddingBottom = 10.px
    }

    val listItem = ClassName(ClassName("SC_listItem")){

        margin = Margin(
            vertical = 9.px,
            horizontal = 0.px
        )
    }
}